module.exports = __webpack_public_path__ + "img/messi-name-m.1d4c9590.svg";